<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">

        <vx-card v-can="'view-goods-out-logistics'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>

              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['Shipment Dispatched','Dispatch Booked','Customer Received','Return','Cancelled']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Shipment Type</label>
              <v-select  :clearable="true" placeholder=""  v-model="is_exw" label="name"
                         :options="[ { name: 'All Shipments', value: null },
                         { name: 'EXW Shipments', value: 1 } , { name: 'Without EXW Shipments', value: 0 }]"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['from']"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['to']"/>
            </div>

          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card v-can="'view-goods-out-logistics'">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'shipment-sheet'" :filters="{...filters, is_exw}"/>
              <vs-button v-can="'create-edit-goods-out-logistics'" @click="onClickShipmentCreate" class="mr-4" color="primary" type="filled">Create (View all orders pending dispatch)</vs-button>
              <vs-button v-can="'create-edit-goods-out-logistics'" @click="onClickShipmentCreateByCustomer" class="mr-4" color="primary" type="filled">Create (View by customer)</vs-button>
            </div>
            </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              id="courier-shipments-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="documents"
              @sort="handleSort"
              :sst="true"
               class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" sort-key="courier_shipment_code">COURIER SHIPMENT CODE</vs-th>
                <vs-th width="10%" sort-key="company_name">COURIER SUPPLIER NAME</vs-th>
                <vs-th width="5%" sort-key="booking_reference_number">BOOKING REF NUMBER</vs-th>
                <vs-th width="5%" >NO OF ITEMS</vs-th>
                <vs-th width="10%" sort-key="customer_company_name">CUSTOMER COMPANY</vs-th>
                <vs-th width="5%" sort-key="type" >SHIPMENT TYPE</vs-th>
                <vs-th width="10%" sort-key="date_of_booking">DATE OF BOOKING</vs-th>
                <vs-th width="10%" sort-key="estimated_delivery_date">ESTIMATE DELIVERY DATE</vs-th>
                <vs-th sort-key="cost_of_delivery" width="10%">COST OF DELIVERY (Excl VAT) in GBP</vs-th>
                <vs-th width="10%" sort-key="status">SHIPMENT STATUS</vs-th>
                <vs-th width="5%"></vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :state="checkAllWorkOrdersStopped(data[indextr].product_items) ? 'danger' : ''" @click.native="onClickUpdateShipment(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].courier_shipment_code">
                    {{ data[indextr].courier_shipment_code}}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].supplier.company_name || 'EXW' }}
                  </vs-td>

                  <vs-td :data="data[indextr].booking_reference_number">
                    {{ data[indextr].booking_reference_number}}
                  </vs-td>
                  <vs-td :data="data[indextr].product_items">
                    {{ (data[indextr] && data[indextr].product_items && data[indextr].product_items.length) || 0 }}
                  </vs-td>

                  <vs-td :data="data[indextr].customer_company_name">
                    <HyperLink :id="data[indextr].customer_id" type="customer">
                    {{ data[indextr].customer_company_name}}
                  </HyperLink>
                  </vs-td>

                  <vs-td class="text-xs" :data="data[indextr].type">
                    {{ data[indextr].type || 'N/A'}}
                  </vs-td>

                  <vs-td :data="data[indextr].date_of_booking">
                    {{data[indextr].date_of_booking}}
                  </vs-td>

                  <vs-td :data="data[indextr].estimated_delivery_date">
                    {{data[indextr].estimated_delivery_date}}
                  </vs-td>

                  <vs-td :data="data[indextr].cost_of_delivery">
                    {{data[indextr].cost_of_delivery}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].status.name">
                    <vs-chip v-if="data[indextr].status.name" style="border-radius: 0" transparent :color="shipmentStatusColorFactory(data[indextr].status.name)">
                    {{data[indextr].status.name  || 'N/A'}}
                    </vs-chip>
                  </vs-td>

                  <vs-td class="text-sm">
                    <span class="cursor-pointer" @click.stop="onClickDhlTracking(data[indextr].tracking_number, data[indextr].courier_shipment_code)">
                      <img v-if="!!data[indextr].tracking_number" src="@/assets/images/pages/dhl/dhl-logo.png" alt="DHL Logo" class="" width="80">
                      <span class="text-danger italic underline">{{data[indextr].tracking_number}}</span>
                    </span>
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">

                      <vx-tooltip  class="ml-0" text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdateShipment(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-can="'create-edit-goods-out-logistics'" v-if="data[indextr].status.name === 'Dispatch Booked' && checkAbilityToDispatch(data[indextr].work_orders)" class="ml-1" text="Shipment Dispatched" position="left">
                        <vs-button @click.stop="onClickShipmentStatusChangeConfirm(data[indextr].id, 'shipment_dispatched', data[indextr].courier_shipment_code)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-upload"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-can="'create-edit-goods-out-logistics'" v-if="data[indextr].status.name === 'Shipment Dispatched'" class="ml-1" text="Customer Received" position="left">
                        <vs-button @click.stop="onClickShipmentStatusChangeConfirm(data[indextr].id, 'customer_received', data[indextr].courier_shipment_code)"
                                   size="small" color="primary" type="filled" icon-pack="feather" icon="icon-download"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-can="'create-edit-goods-out-logistics'" v-if="data[indextr].status.name === 'Customer Received'" class="ml-1" text="Customer Returned" position="left">
                        <vs-button @click.stop="onClickShipmentStatusChangeConfirm(data[indextr].id, 'returned', data[indextr].courier_shipment_code)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-upload"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-can="'cancel-goods-out-logistics'" v-if="data[indextr].status.name === 'Dispatch Booked'" class="ml-1" text="Shipment cancel" position="left">
                        <vs-button @click.stop="onClickShipmentStatusChangeConfirm(data[indextr].id, 'cancelled', data[indextr].courier_shipment_code)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-can="'create-edit-goods-out-logistics'" v-if="data[indextr].status.name === 'Returned' && !data[indextr].related_new_shipment" class="ml-1" text="Regenerate shipment" position="left">
                        <vs-button @click.stop="onClickReGenerateShipment(data[indextr])"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-git-merge"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip v-if="checkAllWorkOrdersStopped(data[indextr].product_items)" class="ml-1" text="no live WO against this shipment" position="left">
                        <vs-button size="small" color="danger" type="filled" icon-pack="feather" icon="icon-alert-octagon"></vs-button>
                      </vx-tooltip>


                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <create-order-shipment-pop-up ref="createOrderShipmentPopUp"/>
    <create-order-shipment-by-customer-pop-up ref="createOrderShipmentByCustomerPopUp"/>
    <update-product-order-shipment-pop-up ref="updateProductOrderShipmentPopUp"/>
    <dhl-shipment-tracking-pop-up ref="dhlShipmentTrackingPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CourierRepository = RepositoryFactory.get('courier')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import StatusColorFactories from '@/mixins/StatusColorFactories'
  import {defaultPagination, perPageList} from "@/constants/config";

  import CreateOrderShipmentPopUp from "@/components/popups/courier/courier-shipment/CreateOrderShipmentPopUp";
  import CreateOrderShipmentByCustomerPopUp from "@/components/popups/courier/courier-shipment/CreateOrderShipmentByCustomerPopUp";
  import UpdateProductOrderShipmentPopUp
    from "@/components/popups/customer/product-orders/UpdateProductOrderShipmentPopUp";
  import DhlShipmentTrackingPopUp from '@/components/popups/courier/courier-shipment/dhp-shipment/DhlShipmentTrackingPopUp.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: 'CourierSupplierShipmenList',
    data () {
      return {
        documents: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        id: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        is_exw: null,
      }
    },
    components: {
      'v-select': vSelect,
      CreateOrderShipmentPopUp,
      UpdateProductOrderShipmentPopUp,
      CreateOrderShipmentByCustomerPopUp,
      DhlShipmentTrackingPopUp,
      flatPickr
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, StatusColorFactories],
    async mounted () {
      this.id = this.$route.params.id
      if(this.$route.query.open) {
        await this.$refs.updateProductOrderShipmentPopUp.openPopup(this.$route.query.open)
      }
    },
    methods: {
      async refreshData () {
        this.fetchSundrySupplierDocuments()
      },
      // shipmentStatusColorFactory(status) {
      //   switch (status) {
      //     case 'Dispatch Booked':
      //       return 'warning';
      //       case 'Shipment Dispatched':
      //         return '#2FDD92';
      //         case 'Returned':
      //           return 'danger';
      //           case 'Customer Received':
      //             return '#34BE82';
      //     case 'Cancelled':
      //       return 'danger';
      //
      //   }
      // },
      async onClickSupplierView (id) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/sundry/${id}`})
      },
      async fetchSundrySupplierDocuments() {
        await this.$vs.loading({
          container: '#courier-shipments-table',
          scale: 0.45
        })

       try {
         if(this.id) {
           const {data} = await CourierRepository.listOfCourierShipments(this.id, this.page, this.filterQuery, this.perPage, this.sort)
           this.documents =  data.data
           this.meta = data.meta
         } else {
           const {data} = await CourierRepository.listOfALlCourierShipments(this.page, this.filterQuery, this.perPage, this.sort)
           this.documents =  data.data
           this.meta = data.meta
         }
       } catch (e) {
          this.convertAndNotifyError(e)
       }


        this.$vs.loading.close('#courier-shipments-table > .con-vs-loading')
      },
      onClickShipmentCreate() {
        this.$refs.createOrderShipmentPopUp.openPopup()
      },
      onClickShipmentCreateByCustomer() {
        this.$refs.createOrderShipmentByCustomerPopUp.openPopup()
      },
      onClickUpdateShipment(id) {
        this.$refs.updateProductOrderShipmentPopUp.openPopup(id)
      },
      async onClickShipmentStatusChangeConfirm(id, status, courier_shipment_code = null) {
        this.$vs.dialog({
            type: 'confirm',
            color: `${status !== 'cancelled' ? 'warning' : 'danger'}`,
            title: `Confirm (${courier_shipment_code})`,
            text: `${status !== 'cancelled' ? 'Are you sure you want to make this change?' : 'Are you sure you want to cancel this shipment?'}`,
            accept: this.onClickShipmentStatusChange,
            parameters: [id, status]
        })
      },
      async onClickShipmentStatusChange(params) {
        await this.$vs.loading({
          container: '#courier-shipments-table',
          scale: 0.45
        })
        try {
          await CourierRepository.shipmentStatusChange(params[0], params[1])
          await this.fetchSundrySupplierDocuments()
          this.showSuccessMessage('Courier shipment status change successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#courier-shipments-table > .con-vs-loading')
      },
      async onClickReGenerateShipment(data) {
        await this.$vs.loading({
          container: '#courier-shipments-table',
          scale: 0.45
        })
        try {
          let payload =  {}
          payload.related_shipment_id = data.id
          payload.supplier_id = data.supplier_id
          payload.type = data.type
          payload.date_of_booking = data.date_of_booking
          payload.estimated_delivery_date = data.estimated_delivery_date
          payload.cost_of_delivery = data.cost_of_delivery
          payload.booking_reference_number = data.booking_reference_number
          payload.gross_weight = data.gross_weight
          payload.net_weight = data.net_weight
          payload.delivery_address = data.delivery_address
          payload.package_details = data.package_details.map((x) => { delete x.product_order_code; return x})
          payload.product_items = data.product_items.map((x) => ({
            item_id: x.id, quantity: x.shipping_quantity, price: x.price
          }))
          payload.work_orders = data.work_orders.map((x) => ({
            work_order_id: x.id, quantity: x.shipping_quantity
          }))
          payload.is_hazardous = data.is_hazardous
          payload.is_shipped_by_limited_quantity = data.is_shipped_by_limited_quantity
          payload.dangerous_goods_details = data.dangerous_goods_details
          payload.notes = data.notes

          await CourierRepository.createProductItemCourierShipment(payload)
          await this.fetchSundrySupplierDocuments()
          this.showSuccessMessage('Courier shipment created successfully')

        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#courier-shipments-table > .con-vs-loading')
      },
      checkAllWorkOrdersStopped(items) {
        let arr = []
        items.forEach((x) => {
          x.work_orders.forEach((n) => {
            arr.push(n)
          })
        })
        const statuses = arr.map((x) => x.wo_status)
        let count = 0
        statuses.forEach((x) => {
          if(x === 'Stopped') {
            count++
          }
        })
        return statuses.length === count && statuses.length !== 0;
      },

      filterQueryUpdate (){
        this.fetchSundrySupplierDocuments()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSundrySupplierDocuments()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSundrySupplierDocuments()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      checkAbilityToDispatch(work_orders) {
        let count = 0
        work_orders.forEach((n) => {
          if(n.status.name === 'Pack Off Completed' && n.q_c_test_status === 'Approved by QC') {
            count++
          }
        })
        return count === work_orders.length
      },
      onClickDhlTracking(tracking_id, courier_shipment_code) {
        this.$refs.dhlShipmentTrackingPopUp.openPopup(tracking_id, courier_shipment_code)
      }
    },
    watch : {
      page(){
        this.fetchSundrySupplierDocuments()
      },
      perPage() {
        this.fetchSundrySupplierDocuments()
      },
      is_exw: function () {
        this.filterQuery = this.filterQuery+'&is_exw='+this.is_exw
        this.fetchSundrySupplierDocuments()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
